// extracted by mini-css-extract-plugin
export var btn_wrapper = "index-module--btn_wrapper--d10a1";
export var close_btn = "index-module--close_btn--57acd";
export var content_btn_wrapper = "index-module--content_btn_wrapper--6a943";
export var content_wrapper = "index-module--content_wrapper--3a3fa";
export var en = "index-module--en--a7977";
export var inner = "index-module--inner--8ff98";
export var jp = "index-module--jp--db57f";
export var page_btn = "index-module--page_btn--d4b81";
export var wrapper = "index-module--wrapper--ab9e1";